/*
 * @Description: 
 * @Author: git config user.name
 * @Date: 2025-09-09 15:38:28
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-09 16:11:51
 * @FilePath: \ngs_platform_manage_admin\src\api\modules\feedBack.js
 */
import request from "../request.js";

// 反馈分页 ---- 孙强
export const getPlatSuggestPage = function (data) {
    return request({
        url: '/userTenantCenter/getPlatSuggestPage',
        method: 'post',
        data
    })
}
//反馈处理  ---- 孙强
export const handleSuggest = function (data) {
    return request({
        url: '/userTenantCenter/handleSuggest',
        method: 'post',
        data
    })
}
//反馈详情  ---- 孙强
export const getPlatSuggestDetail = function (data) {
    return request({
        url: '/userTenantCenter/getPlatSuggestDetail',
        method: 'post',
        data
    })
} 
//处理记录  ---- 孙强
export const getPlatSuggestDealRecord = function (data) {
    return request({
        url: '/userTenantCenter/getPlatSuggestDealRecord',
        method: 'post',
        data
    })
}
